import { render, staticRenderFns } from "./ViewDetailDayLeave.vue?vue&type=template&id=a10520be&scoped=true"
import script from "./ViewDetailDayLeave.vue?vue&type=script&lang=js"
export * from "./ViewDetailDayLeave.vue?vue&type=script&lang=js"
import style0 from "./ViewDetailDayLeave.vue?vue&type=style&index=0&id=a10520be&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10520be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a10520be')) {
      api.createRecord('a10520be', component.options)
    } else {
      api.reload('a10520be', component.options)
    }
    module.hot.accept("./ViewDetailDayLeave.vue?vue&type=template&id=a10520be&scoped=true", function () {
      api.rerender('a10520be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/parentdiary/ViewDetailDayLeave.vue"
export default component.exports